import script from "./ApartmentFlyingStarsLayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApartmentFlyingStarsLayer.vue?vue&type=script&setup=true&lang=ts"

import "./ApartmentFlyingStarsLayer.vue?vue&type=style&index=0&id=68140615&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68140615"]])

export default __exports__